<template>
    <div id="metric_type_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="metricTypeHeader" v-if="$route.params.id > 0">Update Metric Type</span>
                    <span class="page-title" id="metricTypeHeader" v-else>Add Metric Type</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackMetricTypeList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content metric-type-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="MetricTypeForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="type">Type:</label>
                                        <input type="text" class="form-control" v-model="type" id="type" placeholder="Enter Type" name="type">
                                        <div class="field-error">{{type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="uom">UOM:</label>
                                        <input type="text" class="form-control" v-model="uom" id="uom" placeholder="Enter UOM" name="uom">
                                        <div class="field-error">{{uom_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="permissable_min">Permissible Min:</label>
                                        <input type="text" class="form-control" v-model="permissable_min" id="permissable_min" placeholder="Enter Permissible Min" name="permissable_min" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{permissable_min_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="permissable_max">Permissible Max:</label>
                                        <input type="text" class="form-control" v-model="permissable_max" id="permissable_max" placeholder="Enter Permissible Max" name="permissable_max" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{permissable_max_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateMetricTypeBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateMetricType" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateMetricTypeBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateMetricType" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueMetricTypeBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateMetricType(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelMetricTypeBtn" class="btn btn-tertiary" v-on:click.prevent="BackMetricTypeList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "MetricTypeCreate",
  
  metaInfo() {
        return {title: (this.$route.params.id > 0)? "Update Metric Type | " +process.env.COPYRIGHT_NAME : "Create Metric Type | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    type: "",
    uom: "",
    permissable_min: "",
    permissable_max: "",
    description: "",
    loading:false,
    name_error_msg: "",
    type_error_msg: "",
    uom_error_msg: "",
    permissable_min_error_msg: "",
    permissable_max_error_msg: "",
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_metric_type') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            
            if (segments[3]) {
                self.loadMetricType();
            }
        }, 100);
  },
  methods: {
    BackMetricTypeList() {
      var self = this;
      self.$router.push("/metrictype/list");
    },

    CreateMetricType(flag) {
      var self = this;
      var error = false;

      self.type = self.type.trim();
      self.name = self.name.trim();

      self.name_error_msg = "";
      self.type_error_msg = "";
      self.uom_error_msg = "";
      self.permissable_min_error_msg = "";
      self.permissable_max_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
        error = true;
      }

      if (!self.type || self.type == null || self.type == "") {
        self.type_error_msg = "Type Required.";
        error = true;
      }

      if (!self.uom || self.uom == null || self.uom == "") {
        self.uom_error_msg = "UOM Required.";
        error = true;
      }

        // if(self.permissable_min && !String(self.permissable_min).match(/^[0-9]*$/)){
        //     self.permissable_min_error_msg = "Permissable Min Numeric";
        //     error = true;
        // }

        // if(self.permissable_max && !String(self.permissable_max).match(/^[0-9]*$/)){
        //     self.permissable_max_error_msg = "Permissable Max Numeric";
        //     error = true;
        // }
      
      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateMetricTypeBtn").val("Updating ...");
                $("#CreateMetricTypeBtn").prop("disabled", true);
                $("#cancelMetricTypeBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueMetricTypeBtn").val("Saving ...");
                    $("#CreateMetricTypeBtn").prop("disabled", true);
                    $("#createAndContinueMetricTypeBtn").prop("disabled", true);
                    $("#cancelMetricTypeBtn").prop("disabled",true);

                }else{

                    $("#CreateMetricTypeBtn").val("Saving ...");
                    $("#CreateMetricTypeBtn").prop("disabled", true);
                    $("#createAndContinueMetricTypeBtn").prop("disabled", true);
                    $("#cancelMetricTypeBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/metrictype/create",
                type: "POST",
                data: {
                    name: self.name,
                    id: segments[3],
                    type: self.type,
                    uom: self.uom,
                    permissable_min: self.permissable_min,
                    permissable_max: self.permissable_max,
                    description: self.description
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateMetricTypeBtn").val("Update");
                        $("#CreateMetricTypeBtn").prop("disabled", false);
                        $("#cancelMetricTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueMetricTypeBtn").val("Save and Continue");
                            $("#CreateMetricTypeBtn").prop("disabled", false);
                            $("#createAndContinueMetricTypeBtn").prop("disabled", false);
                            $("#cancelMetricTypeBtn").prop("disabled",false);

                        }else{

                            $("#CreateMetricTypeBtn").val("Save");
                            $("#CreateMetricTypeBtn").prop("disabled", false);
                            $("#createAndContinueMetricTypeBtn").prop("disabled", false);
                            $("#cancelMetricTypeBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#MetricTypeForm").trigger("reset");
                            self.name ="";
                            self.type = "";
                            self.permissable_min = "";
                            self.permissable_max = "";
                            self.uom = "";
                    
                        }else{
                            self.$router.push("/metrictype/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateMetricTypeBtn").val("Update");
                        $("#CreateMetricTypeBtn").prop("disabled", false);
                        $("#cancelMetricTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#MetricTypeForm").trigger("reset");
                            

                            $("#createAndContinueMetricTypeBtn").val("Save and Continue");
                            $("#CreateMetricTypeBtn").prop("disabled", false);
                            $("#createAndContinueMetricTypeBtn").prop("disabled", false);
                            $("#cancelMetricTypeBtn").prop("disabled",false);

                        }else{

                            $("#CreateMetricTypeBtn").val("Save");
                            $("#CreateMetricTypeBtn").prop("disabled", false);
                            $("#createAndContinueMetricTypeBtn").prop("disabled", false);
                            $("#cancelMetricTypeBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'metric-type-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }
     
    },

    loadMetricType() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/metrictype/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.uom = data.content.uom;
                    self.type = data.content.type;
                    self.permissable_min = data.content.permissable_min;
                    self.permissable_max = data.content.permissable_max;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'metric-type-by-id')
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/MetricTypeCreate.vue